function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { j as t } from "./index.es33.js";
import { clsx as s } from "./index.es105.js";
import "./index.es13.js";
import { TooltipShorten as u } from "./index.es14.js";
import "./index.es15.js";
import { Typography as y } from "./index.es35.js";
import "./index.es36.js";
import { useSelectContext as g } from "./index.es132.js";
import { SelectSize as i } from "./index.es135.js";
import e from "./index.es428.js";

var B = function B(_ref) {
  var _s;

  var o = _ref.children,
      n = _ref.isSelected,
      m = _ref.value,
      a = _ref.isDisabled,
      r = _ref.onClick,
      _ref$size = _ref.size,
      p = _ref$size === void 0 ? i.normal : _ref$size,
      _ref$className = _ref.className,
      c = _ref$className === void 0 ? "" : _ref$className,
      _ref$isTruncated = _ref.isTruncated,
      f = _ref$isTruncated === void 0 ? !1 : _ref$isTruncated,
      _ref$isPreWrap = _ref.isPreWrap,
      l = _ref$isPreWrap === void 0 ? !1 : _ref$isPreWrap,
      _ref$isDivided = _ref.isDivided,
      x = _ref$isDivided === void 0 ? !1 : _ref$isDivided;

  var _g = g(),
      d = _g.onOptionClick,
      j = _g.setIsOpen,
      C = _g.preventCloseOnSelect,
      S = function S() {
    r ? r() : d === null || d === void 0 ? void 0 : d(m), C || (j === null || j === void 0 ? void 0 : j(!1));
  };

  return t.jsxs(t.Fragment, {
    children: [t.jsx("li", {
      children: t.jsx("button", {
        type: "button",
        className: s(e.listItemControl, c, (_s = {}, _defineProperty(_s, e.listItemControlLarge, p === i.large), _defineProperty(_s, e.listItemControlSelected, n), _defineProperty(_s, e.optionLabelPreserveSpaces, l), _s)),
        disabled: a,
        onClick: S,
        children: typeof o == "string" ? t.jsx(u, {
          contentClassName: s(_defineProperty({}, e.tooltipPreserveSpaces, l)),
          title: o
        }) : t.jsx(y.Body2, {
          as: "span",
          className: s(e.inner, _defineProperty({}, e.innerTruncated, f)),
          children: o
        })
      })
    }), x && t.jsx("div", {
      className: e.divider
    })]
  });
};

export { B as Option };